import { COLORS } from 'helpers/globals'

const Panel = {
  borderBottom: `1px solid ${COLORS.quaternary}`
}
const triangle = {
  width: 0,
  height: 0
}

export default {
  Panel,
  'Panel-active': {
    ...Panel,
    padding: '0rem .8rem 0rem .8rem',
    borderTop: `1px solid ${COLORS.quaternary}`
  },
  'Panel-inactive': Panel,
  active: {
    display: 'inherit',
    paddingTop: '.8rem'
  },
  inactive: {
    display: 'none',
    paddingTop: '.8rem'
  },
  triangleContainer: {
    display: 'inline-block',
    marginRight: '.4rem',
    height: 12,
    width: 12
  },
  triangle,
  'triangle-active': {
    ...triangle,
    borderLeft: '6px solid transparent',
    borderRight: '6px solid transparent',
    borderTop: `10px solid ${COLORS.secondary}`
  },
  'triangle-inactive': {
    ...triangle,
    borderTop: '6px solid transparent',
    borderBottom: '6px solid transparent',
    borderLeft: `10px solid ${COLORS.secondary}`
  },
  header: {
    padding: '.5rem',
    backgroundColor: COLORS.tertiary
  },
  link: { color: 'black' }
}



// WEBPACK FOOTER //
// ./src/components/Panel/style.js